import { Box, Divider, Group, Text } from "@mantine/core";
import { heading } from "../../../types/types";

export function Heading(props: heading){
    return(
        <Box>
            <Group spacing={3}>
            <Divider
                sx={{ height: "24px" }}
                size="sm"
                orientation="vertical"
                color="#02BBd5"
            />
            <Text weight={700}>{props.mainHeading}</Text>
            </Group>
            {props.subHeading && <Box>
            <Text color="dimmed" size="xs" ml={6}>
                {props.subHeading}
            </Text>
            </Box>}
        </Box>
    )
}